import { render, staticRenderFns } from "./RedirectPage.vue?vue&type=template&id=3a3eec3c&scoped=true&"
import script from "./RedirectPage.vue?vue&type=script&lang=js&"
export * from "./RedirectPage.vue?vue&type=script&lang=js&"
import style0 from "./RedirectPage.vue?vue&type=style&index=0&id=3a3eec3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3eec3c",
  null
  
)

export default component.exports